import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

function Title(props){

  return(
    <Grid
      container
      p={5}
      id={props.id}
    >
    <Grid
      item
      xs={12}
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center'
      }}
    >
      <Typography variant="h1"color={props.titleColor}>{props.title}</Typography>
    </Grid>
    <Grid
      pt={3}
      item
      xs={12}
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center'
      }}
    >
      <Typography variant="h3" color={props.subTitleColor}>{props.subTitle}</Typography>
    </Grid>
   
    </Grid>
  )
}

export default Title;